import { replace } from "ramda";
import translate from "./translate";

// "message ${param}""
export default function translateWithParams(key, params) {
  const message = translate(key);
  return Object.keys(params).reduce((acc, k) => {
    return replace(`$\{${k}}`, params[k], acc);
  }, message);
}
